/**
 * Pro price shown in the app and on the marketing site. The charge itself is
 * the Whop plan behind the checkout link, so keep these in step with Whop:
 *   - RiskLo self-use (risklo.io, no company): WHOP_CHECKOUT_URL → $30/month plan
 *   - Members of a Partner brand (e.g. Vector): the brand's own checkout link → $20/month
 */
import { getCurrentBrand } from './activeEntity';
import { getBrandPlan, isBrandFirstPlan } from './brandIdentity';

export const PRO_PRICE = 30;
export const PRO_PARTNER_PRICE = 20;
export const PRO_TRIAL_DAYS = 7;

/** RiskLo AI questions included each month (server: aiAssistant/config.js DEFAULT tier limits). */
export const AI_MONTHLY_QUESTIONS = { basic: 0, pro: 200, max: 600 };

/** True when the active brand is a Partner brand whose members get the lower Pro price. */
export function hasPartnerProPrice(brand = getCurrentBrand()) {
  const slug = String(brand?.slug || '').toLowerCase();
  if (!slug || slug === 'risklo') return false;
  return isBrandFirstPlan(getBrandPlan(brand));
}

/** { amount, label, partner } for the active brand. */
export function proPriceFor(brand = getCurrentBrand()) {
  const partner = hasPartnerProPrice(brand);
  const amount = partner ? PRO_PARTNER_PRICE : PRO_PRICE;
  return { amount, label: `$${amount}`, partner };
}
